import { ImageBackground, Platform, StyleSheet } from 'react-native';

import { TransparentRow } from './Row';
import { TextCtaButton } from './StyledText';
import { View } from './Themed';
import Colors from '../constants/Colors';
import useColorScheme from '../hooks/useColorScheme';

const DefaultWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <TransparentRow style={{ gap: 20, flexWrap: 'wrap' }}>
      {children}
    </TransparentRow>
  );
};

export default function ChildCareOfferings({
  Wrapper = DefaultWrapper,
}: {
  Wrapper?: ({ children }: { children: React.ReactNode }) => React.ReactNode;
}) {
  const theme = useColorScheme();
  return (
    <Wrapper>
      <View>
        <ImageBackground
          source={require('../assets/images/offerings-1.png')}
          style={[
            {
              borderColor: Colors[theme].accent,
              width: 290,
              height: 290,
              borderRadius: 290 / 2,
              borderWidth: 10,
              overflow: 'hidden',
            },
            styles.radius,
          ]}
        />
        <TextCtaButton style={styles.textCta}>
          Infant Care (0 to 12 mo)
        </TextCtaButton>
      </View>
      <View>
        <ImageBackground
          source={require('../assets/images/offerings-2.png')}
          style={[
            {
              borderColor: Colors[theme].accent,
              width: 290,
              height: 290,
              borderRadius: 290 / 2,
              borderWidth: 10,
              overflow: 'hidden',
            },
            styles.radius,
          ]}
        />
        <TextCtaButton style={styles.textCta}>
          Toddler Care (12 to 36 mo)
        </TextCtaButton>
      </View>
      <View>
        <ImageBackground
          source={require('../assets/images/offerings-3.png')}
          style={[
            {
              borderColor: Colors[theme].accent,
              width: 290,
              height: 290,
              borderRadius: 290 / 2,
              borderWidth: 10,
              overflow: 'hidden',
            },
            styles.radius,
          ]}
        />
        <TextCtaButton style={styles.textCta}>
          Little kid camps (3 to 6 yo)
        </TextCtaButton>
      </View>
      <View>
        <ImageBackground
          source={require('../assets/images/offerings-4.png')}
          style={[
            {
              borderColor: Colors[theme].accent,
              width: 290,
              height: 290,
              borderRadius: 290 / 2,
              borderWidth: 10,
              overflow: 'hidden',
            },
            styles.radius,
          ]}
        />
        <TextCtaButton style={styles.textCta}>
          Big kid camps (6 to 11 yo)
        </TextCtaButton>
      </View>
    </Wrapper>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  // @ts-ignore
  radius: {
    ...Platform.select({
      web: {
        borderRadius: '50%',
      },
    }),
  },
  textCta: {
    marginTop: 20,
    textAlign: 'center',
  },
});
